import * as React from "react";
import {cn} from "@/lib/utils";

function Progress({
    value,
    className,
    ...props
}: React.HTMLAttributes<HTMLDivElement> & { value: number }) {
    const normalized = Math.min(100, Math.max(0, value));
    return <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={normalized}
        className={cn("h-2 w-full overflow-hidden rounded-full bg-secondary", className)}
        {...props}
    >
        <div
            className="h-full bg-success transition-[width] duration-300 ease-out"
            style={{width: `${normalized}%`}}
        />
    </div>;
}

export {Progress};
